/* eslint-disable @typescript-eslint/no-unsafe-assignment */
/** 无标签首页-授信金融卡片 */
import {
  Component, Mixins, Prop,
} from 'vue-property-decorator';

import FinanceBusiness from '@/mixins/finance-business';
import platform from '@/shared/utils/platform';
import { isH5App } from '@/constant';
import { namespace } from 'vuex-class';
import { creditTaskStatusTypeEnum } from '@/enums/autarkyUpgrade';
import {
  HomeThemeEnums, getHomeThemeBodyConfig,
} from '@/shared/utils/pageTheme';
import { styleNumPxToVm } from '@/shared/utils/style-unit';
import { useMaxQuotaFormatted } from '@/shared/utils/getMaxQuota';
import { NormalPreCreditModelEnums, PreCreditUserSourceEnums, UserHomeSceneEnums } from '@/enums/home-type';
import CouponInfo from '@/pages/home/components/FinanceCard/FinanceNormalCard/components/CouponInfo/index.vue';
import RepayItem from '@/views_v2/home/components/repay-item/index.vue';
import { getMajorQuotaText, isCreditTaskOcrSuspend } from '@/pages/home/utils';
import TaglessButton from './components/credit-button';
import AliminiCreditButtons from '../alimini-credit-buttons';
import ThemeBanner from '../theme-banner';
import AdvMarketCard from '../adv-market-card';
import IdentityExpiresBar from '../identity-expires-bar';
import { formatCreditAmount } from '../utils';

import style from './index.module.scss';

const HomeStore = namespace('home');

@Component
export default class FinanceCreditCard extends Mixins(
  FinanceBusiness,
) {
  @HomeStore.State showTaglessCard!: boolean

  // 响应式最高额度格式化文案
  private maxQuotaFormatted = useMaxQuotaFormatted();

  @HomeStore.State marketSource!: string;

  @HomeStore.State marketHasLoaded!: boolean;

  @HomeStore.State homeThemeType!: HomeThemeEnums;

  @HomeStore.Action $updateState!: (data: Dictionary) => void;

  // 按钮展示的文案内容
  @Prop({
    type: String,
    default: '',
  }) readonly buttonName!: string;

  // 是否显示动态效果
  @Prop({
    type: Boolean,
    default: '',
  }) readonly isAnimateBtn!: boolean;

  private emitCreditAmount(e: Event) {
    this.$emit('emitClick', e);
  }

  /** 去补充资料 */
  private addInfo(e: Event) {
    this.$emit('emitClick', e);
  }

  private get homeClassName() {
    return platform.isHelloApp ? 'home-card' : 'home-card-noNav';
  }

  private get aliMiniAndDingTalk() {
    return platform.isAlipayMini || platform.isDingTalk;
  }

  private mounted() {
    const { preCreditUserSource = '', normalPreCreditModel = '' } = this.creditData || {};
    const userInfo = this.businessInfoExtra?.userInfo || {};
    /** 金融卡片-模块曝光埋点 */
    this.$ubtModuleExposeNew('finance_loan_home_financeCard', {
      scene: this.creditData?.preCredit
        ? UserHomeSceneEnums.PRE_CREDIT : UserHomeSceneEnums.TAGLESS,
      preCreditUserSource,
      normalPreCreditModel,
      //  // 包含定价标签（pricingTag）、风险标签（risk24UserSource）等用户信息
      ...userInfo,
    });
  }

  private render() {
    const {
      creditTaskStatus,
      identityExpiresFor30,
      preCredit,
      preCreditUserSource,
      creditAmount,
      normalPreCreditModel,
      freeCouponType,
      couponNameMoney,
      couponNameDay,
      hasOrder,
    } = this.creditData || {};
    const themeBannerConfig = getHomeThemeBodyConfig(this.homeThemeType, this.$route.name);
    const { isValidTheme, bgTransitionStyle } = themeBannerConfig;
    /** 是否进入授信流程的预授信用户 */
    const isCreditPreCredit = normalPreCreditModel === NormalPreCreditModelEnums.CREDIT;
    /** 是否普通预授信模式 */
    const isNormalPreCredit = preCredit
    && [PreCreditUserSourceEnums.NORMAL, PreCreditUserSourceEnums.SEA_CONSUMER]
      .includes(preCreditUserSource);
    const majorQuotaText = getMajorQuotaText(this.creditData);
    /** 是否展示券信息 */
    const showCouponInfo = freeCouponType && couponNameMoney && couponNameDay;
    /** 综合年化利率-上下限 */
    const { rateFloor, rateCeil } = this.businessInfoExtra?.creditInfo || {};
    /** 是否展示附属卡片板块：还款入口) */
    const showAttachedWrapper = !!hasOrder;
    const supplementText = isCreditTaskOcrSuspend(this.creditData)
      ? '提交审批'
      : '加速审批';

    return (
      <div
        class={[
          style[this.homeClassName],
          isValidTheme && style.promoteThemeBox,
        ]}
        style={[isValidTheme && bgTransitionStyle]}>
        <ThemeBanner
          themeConfig={themeBannerConfig}
          onThemeBannerClick={(e: Event) => {
            this.emitCreditAmount(e);
            this.$ubtPageButton('finance_taglessHome_bannerClick');
          }}
        />
        {!isValidTheme
          ? <div class={[style.slogan, (this.aliMiniAndDingTalk || isH5App) && style.margin]} />
          : null}
        <div>
          <div class={[style.financeCard, showAttachedWrapper && style.splitShadow]}>
            <p class={style.availableTitle}>
              <span class={style.availableText}>{majorQuotaText}</span>
            </p>
            <p class={style.possibleNum}>
              {(preCredit || isCreditPreCredit)
                ? formatCreditAmount(creditAmount)
                : this.maxQuotaFormatted.value}
            </p>
            <p class={style.description}>
              综合年化利率(单利){rateFloor}%-{rateCeil}%
            </p>
            {/** 当有广告卡片的时候，上下间距由23变成18，券信息卡片不展示广告卡片 */}
            {!showCouponInfo && (
              <AdvMarketCard cardValidStyle={{ marginTop: `${styleNumPxToVm(-5)}vw` }} />
            )}
            {this.creditData && showCouponInfo && (
              <CouponInfo
                userCreditData={this.creditData}
                className={'homeCouponInfo'}
              />
            )}
            {/** “申请额度”按钮,支付宝小程序按钮需定制化展示 */}
            {!this.aliMiniAndDingTalk
              ? (
                <div class={style.buttonWrapper}>
                  <TaglessButton
                    buttonName={this.buttonName}
                    isAnimateBtn={this.isAnimateBtn}
                    onEmitClick={this.emitCreditAmount.bind(this)} />
                    {/* 预授信 额度提醒tips */}
                    {isNormalPreCredit && <div class={style.preCreditTip}>最终可借额度以放款方审核为准</div>}
                </div>)
              : (
                <div class={style.buttonWrapper}>
                  <AliminiCreditButtons newButton={true} />
                </div>)
            }
            {/** 身份证有效期小于30天，提醒用户更新bar */}
            <IdentityExpiresBar
              visible={identityExpiresFor30}
              class={style.customIdentityExpires} />
          </div>
          {showAttachedWrapper
            && (
              <div class={style.attachedWrapper}>
                {hasOrder && <RepayItem customStyle={{ padding: `${styleNumPxToVm(15)}vw 0` }} />}
              </div>
            )}
        </div>
        {/* 补充资料模块-哈啰 app 内展示
        展示逻辑：极简流程 授信挂起状态（ 流量分发，命中自营 B 在第一位，且有联营导流渠道，自营 B 授信失败，联营||导流未补充资料场景）
        */}
        {(creditTaskStatus && creditTaskStatus === creditTaskStatusTypeEnum.HANG) ? (
          <div class={style.addInfo} onClick={this.addInfo.bind(this)}>
            <div class={style.addInfoLeft}>
              <div class={style.leftIcon}></div>
              <div class={style.leftContent}>
                <div class={style.mainContent}>补充资料 {supplementText}</div>
                <div class={style.subContent}>您有一笔申请待补充资料</div>
              </div>
            </div>
            <div class={style.addInfoRight}>
              <div
                class={style.btn}
              >
                去补充
              </div>
            </div>
          </div>
        ) : null}
      </div>
    );
  }
}
